module.exports = __webpack_public_path__ + "img/1.4e4ffd33.png";